import { Select as SelectBase } from 'antd'
import LinkBase from 'next/link'
import { usePathname } from 'next/navigation'
import styled from 'styled-components'

import { colors, emSpaces as spaces } from '@/config/global-parameters'

const { Option } = SelectBase

export const NAV_LINKS = [
  {
    href: '/2023/plebiscito',
    key: 'general',
    label: 'General',
    matchRegex: /\/2023\/plebiscito$/g,
  },
  {
    href: '/2023/plebiscito/region/metropolitanadesantiago',
    key: 'regiones',
    label: 'Regiones',
    matchRegex: /\/2023\/plebiscito\/region\/(.*)$/g,
  },
  {
    href: '/2023/plebiscito/extranjero',
    key: 'extranjero',
    label: 'Extranjero',
    matchRegex: /\/2023\/plebiscito\/extranjero$/g,
  },
  {
    href: 'https://www.decidechile.cl/analisis',
    key: 'analisis_electoral',
    label: 'Análisis Electoral',
    matchRegex: /nomatch$/g,
    newTab: true,
  },
]

const SelectorMenu = ({ className, currentLink, links, placeholder }) => {
  return (
    <Select
      bordered={false}
      className={className}
      defaultValue={currentLink}
      dropdownRender={(item) => <SelectItem>{item}</SelectItem>}
      placeholder={placeholder}
      value={currentLink}
    >
      {links.map(({ href, key, label }) => (
        <Option key={key}>
          <Link href={href}>{label}</Link>
        </Option>
      ))}
    </Select>
  )
}

const ButtonMenu = ({ className, currentLink, links }) => {
  const itemProps = ({ key, newTab }) => {
    const defaultProps = {
      active: (currentLink === key).toString(),
    }
    if (newTab) {
      defaultProps.target = '_blank'
      defaultProps.rel = 'noopener noreferrer'
    }
    return defaultProps
  }
  return (
    <ButtonMenuWrapper className={className}>
      {links.map(({ href, key, label, newTab }) => (
        <Link
          href={href}
          key={key}
          passHref
          {...itemProps({ key, newTab })}
        >
          {label}
        </Link>
      ))}
    </ButtonMenuWrapper>
  )
}

export default function NavigationLinks({
  links = NAV_LINKS,
  onlySelector = false,
  placeholder = 'P. Salida',
}) {
  const pathname = usePathname()
  const selectedValue = links.find(({ matchRegex }) => pathname.match(matchRegex))?.key

  return (
    <Wrapper onlySelector={onlySelector}>
      {!onlySelector && (
        <ButtonMenu
          currentLink={selectedValue}
          links={links}
        />
      )}
      <SelectorMenu
        links={links}
        placeholder={placeholder}
      />
    </Wrapper>
  )
}

const ButtonMenuWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 2em;
`

const Select = styled(SelectBase)`
  width: 100%;
  max-width: 200px;
  :where(.css-dev-only-do-not-override-2q8sxy).ant-select-single:not(.ant-select-customize-input)
    .ant-select-selector {
    padding: 0 0.5em;
  }
  .ant-select-selection-placeholder {
    color: ${colors.colorGrey8};
  }
  .ant-select-arrow {
    color: ${colors.colorGrey8};
  }
`

const Wrapper = styled.div`
  ${Select} {
    ${({ onlySelector }) => !onlySelector && 'display: none;'}
    .ant-select-selection-item {
      pointer-events: none;
    }
  }
  @media (max-width: ${spaces.tabletBreakpoint}) {
    ${ButtonMenuWrapper} {
      display: none;
    }
    ${Select} {
      display: inherit;
    }
  }
`

const Link = styled(LinkBase)`
  color: ${({ active }) => ((active === "true") ? colors.decidechileBlue : colors.colorGrey8)};
  &:visited {
    text-decoration: underline;
    text-decoration-color: ${({ active }) => ((active === "true") ? colors.decidechileBlue : colors.colorGrey8)};
  }
  font-weight: 400;
  font-size: 14px;
  :hover {
    font-weight: 700;
    color: ${colors.decidechileBlue};
  }
`

const SelectItem = styled.span``
